<template>
  <fieldset class="fieldset-element">
    <legend v-if="fieldData.title">{{ fieldData.title }}</legend>
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <div v-for="field in fieldData.fields" :key="field.name">
      <form-component :field="field" ref="fieldsetcomponents" />
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "form-fieldset",
  props: ["fieldData"],
  data() {
    return {
      valid: false
    }
  },
  // This is a circular reference so we must register it as per the docs
  // https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
  beforeCreate: function () {
    this.$options.components.FormComponent = require("./FormComponent.vue").default;
  },
  methods: {
    validateField() {
      let validation = true;
      this.$refs.fieldsetcomponents.forEach((item) => {
        item.validateField();
        if (!item.valid) {
          validation = false;
        }
      });
      this.valid = validation;
    },
  },
};
</script>